import { React } from 'react'
import Controller from '../../components/taxonomies/controller'
import MetaTags from '../../components/MetaTags'

function Category({ item, list, menu, config, filter_list, brand_list, price }) {

    return (
        <>
            <MetaTags item={item} config={config}></MetaTags>
            <Controller item={item} list={list} menu={menu} config={config} filter_list={filter_list} brand_list={brand_list} price={price}></Controller>
        </>
    )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
    const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
    const config_data = await config_res.json()
    const config = config_data.data

    const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
    const menu = await menu_res.json()

    const taxres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/brand/' + context.params.url[0])
    const taxresponse = await taxres.json()
    const category = (taxresponse.data) ? (taxresponse.data) : (false)

    const filterres = await fetch(
        process.env.NEXT_PUBLIC_API_URL + '/taxonomy-filtered',
        {
            body: JSON.stringify({
                device_name: 'browser',
                type: 'filter',
                slug: context.params.url[0]
            }),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST'
        }
    )
    const filterresponse = await filterres.json()
    const filter_list = filterresponse.data

    const brandres = await fetch(
        process.env.NEXT_PUBLIC_API_URL + '/taxonomy-filtered',
        {
            body: JSON.stringify({
                device_name: 'browser',
                type: 'brand',
                slug: context.params.url[0]
            }),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST'
        }
    )
    const brandresponse = await brandres.json()
    const brand_list = brandresponse.data

    const page = (context.params.page) ? context.params.page : '1'
    const sort = (context.params.sort) ? context.params.sort : 'a-z'

    const listres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies-products/brand/' + context.params.url[0] + '?page=' + page + '&sort=' + sort)
    const listresponse = await listres.json()
    const list = listresponse.data

    const priceres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/get_min_and_max_prices/brand/' + context.params.url[0])
    const priceresponse = await priceres.json()
    const price = priceresponse.data


    if (!category) {
        return {
            notFound: true
        }
    }

    return {
        props: {
            config: config,
            menu: menu,
            item: category,
            list: list,
            filter_list: filter_list,
            brand_list: brand_list,
            price: price,
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 600, // In seconds

    }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths() {
    const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/brand')
    const response = await res.json()
    const categories = response.data

    // Get the paths we want to pre-render based on products
    const paths = categories.map((category) => ({
        params: {
            url: [category.url.toString()],
            page: '1',
            sort: 'a-z'
        },
        params: {
            url: [category.url.toString()],
            page: '1',
            sort: 'z-a'
        },
        params: {
            url: [category.url.toString()],
            page: '1',
            sort: 'low-high'
        },
        params: {
            url: [category.url.toString()],
            page: '1',
            sort: 'high-low'
        },
    }))

    // We'll pre-render only these paths at build time.
    // { fallback: blocking } will server-render pages
    // on-demand if the path doesn't exist.
    return { paths, fallback: 'blocking' }
}


export default Category